import { render } from "./Principal.vue?vue&type=template&id=13fd618f&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-13fd618f"

export default script